module.exports = __webpack_public_path__ + "static/media/six-sense-logo-old.34d2b7f3.svg";